import React, { useState } from 'react';

const TopCustomersList = ({ data, filters }) => {
  const getDateStr = (date) =>
    date instanceof Date
      ? date.toLocaleDateString('en-CA')
      : new Date(date).toLocaleDateString('en-CA');

  // Filter data
  const filtered = data.filter((d) => {
    const matchDate = !filters.selectedDate || getDateStr(d.Date) === filters.selectedDate;
    return (!filters.customer || d.Customer === filters.customer) && matchDate;
  });

  // Initialize counts
  const handledCounts = {};
  const missedCounts = {};
  const rejectedCounts = {};
  const abandonedCounts = {};

  filtered.forEach((d) => {
    const customer = d.Customer || 'Unknown';

    if (!handledCounts[customer]) handledCounts[customer] = 0;
    if (!missedCounts[customer]) missedCounts[customer] = 0;
    if (!rejectedCounts[customer]) rejectedCounts[customer] = 0;
    if (!abandonedCounts[customer]) abandonedCounts[customer] = 0;

    handledCounts[customer] += d.Handled || 0;
    missedCounts[customer] += d.Missed || 0;
    rejectedCounts[customer] += d.Rejected || 0;
    abandonedCounts[customer] += d.Abandoned || 0;
  });

  // Sort descending by count
  const sortedHandled = Object.entries(handledCounts).sort((a, b) => b[1] - a[1]);
  const sortedMissed = Object.entries(missedCounts).sort((a, b) => b[1] - a[1]);
  const sortedRejected = Object.entries(rejectedCounts).sort((a, b) => b[1] - a[1]);
  const sortedAbandoned = Object.entries(abandonedCounts).sort((a, b) => b[1] - a[1]);

  // State for each section
  const [showAllHandled, setShowAllHandled] = useState(false);
  const [showAllMissed, setShowAllMissed] = useState(false);
  const [showAllRejected, setShowAllRejected] = useState(false);
  const [showAllAbandoned, setShowAllAbandoned] = useState(false);

  const renderList = (title, list, showAll, setShowAll) => {
    const displayList = showAll ? list : list.slice(0, 10);

    return (
      <div style={{ marginBottom: 20 }}>
        <h4>{title}</h4>
        <ul style={{ paddingLeft: 20, listStyle: 'none', fontSize: '0.8rem' }}>
          {displayList.map(([customer, count], i) => (
            <li key={`${title}-${customer}`}>
              <p style={{ padding: 0, margin: 0 }}><strong style={{ marginRight: '1rem' }}>{i + 1}.</strong> {customer}: <strong>{count}</strong></p>
            </li>
          ))}
        </ul>
        {list.length > 10 && (
          <button
            onClick={() => setShowAll(!showAll)}
            className='toplist-loadmore'
          >
            {showAll ? 'Show Less' : 'Load More'}
          </button>
        )}
      </div>
    );
  };

  return (
    <div style={{ marginTop: 20 }}>
      {renderList('Handled Calls', sortedHandled, showAllHandled, setShowAllHandled)}
      {renderList('Missed Calls', sortedMissed, showAllMissed, setShowAllMissed)}
      {renderList('Rejected Calls', sortedRejected, showAllRejected, setShowAllRejected)}
      {renderList('Abandoned Calls', sortedAbandoned, showAllAbandoned, setShowAllAbandoned)}
    </div>
  );
};

export default TopCustomersList;
